import { Divider } from 'common/common-components.styled';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
  position: absolute;
  top: 0;
  right: -20px;
  height: 100%;
`;
